const integrationsDictIT = {
  // Integrazioni
  integrations: "Integrazioni",
  integrationsDescription:
    "Accedi a strumenti e applicazioni integrati pronti per le tue attività su Extraconomy.",
  configure: "Configura",
  integrationData: "Dati di integrazione",

  // WhatsApp
  whatsappIntegrationDescription: "Gestisci il numero di contatto visibile nel tuo negozio.",
  phoneNumber1: "Numero di Telefono",
  enterYourPhoneNumber: "Inserisci il tuo numero di telefono",
  confirmationCode: "Codice di Conferma",
  enterReceivedCode: "Inserisci il codice ricevuto",
  goBackAndResendCode: "Torna indietro e reinvia il codice",

  // Messaggi
  attention: "Attenzione",
  success: "Successo",
  error: "Errore",
  codeSent: "Codice Inviato",
  codeSentTo: "Codice inviato a",

  // Validazioni
  pleaseProvidePhoneNumber: "Si prega di fornire il numero di telefono",
  pleaseProvideConfirmationCode: "Si prega di fornire il codice di conferma",

  // Successo
  confirmationCodeSentToWhatsApp: "Codice di conferma inviato a WhatsApp",
  whatsappConfiguredSuccessfully: "WhatsApp configurato con successo!",
  configurationSavedSuccessfully: "Configurazione salvata con successo",

  // Errori
  errorConnectingToServer: "Errore di connessione al server",
  invalidConfirmationCode: "Codice di conferma non valido",
  errorConfirmingCode: "Errore nella conferma del codice",
};

export default integrationsDictIT;
